// dependencies
import React, { useEffect, useState } from "react";

// SelectInput
import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

// Config
import { ColumnsConfig } from "../../../pages/Report/ColumnsConfig";
// report analytics store
import useStore from "../../../pages/Report/store/index";

// store
import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: unknown;
	isDisabled: boolean;
}

const CustomFieldPicker = (props: BaseProps) => {
	const [fields, setFields] = useState<Result[]>([]);
	const { onChange, value, isDisabled } = props;
	const [fetchCustomFields] = useQueryBuilderStore((state) => [state.fetchCustomFields]);
	const [availableGridColumns, report] = useStore((state) => [state.availableGridColumns, state.report]);

	const getFields = async () => {
		const employees = await fetchCustomFields();
		const additionalEmployeeFields = Object.keys(ColumnsConfig.employeeFields).map((field) => {
			const fieldData = ColumnsConfig.employeeFields[field];
			return {
				label: fieldData.name,
				value: fieldData.name,
				type: fieldData.type,
			};
		});

		// Filter out "Has Direct Reports" field for non-employee report types
		const filteredAdditionalEmployeeFields = additionalEmployeeFields.filter((field) => {
			if (field.label === "Has Direct Reports") {
				return report?.type === "employeeReport";
			}
			return true;
		});

		// sorted employees custom fields list and additional employee fields list
		const sortedAllEmployeeFieldsUnfiltered = [...employees, ...filteredAdditionalEmployeeFields].sort((a, b) => {
			if (a.label < b.label) return -1;
			if (a.label > b.label) return 1;
			return 0;
		});
		const filtered_available_columns = availableGridColumns
			.filter((x) => x.fieldType === "EMPLOYEE_FIELD")
			.map((x) => x.headerName);

		const sortedAllEmployeeFields = sortedAllEmployeeFieldsUnfiltered.filter((employee_field) =>
			filtered_available_columns.includes(employee_field.label)
		);
		setFields(sortedAllEmployeeFields);
	};

	useEffect(() => {
		getFields();
	}, [report?.type]);

	return (
		<SelectInput cacheOptions onChange={onChange} results={fields} value={value as Result} disabled={isDisabled} />
	);
};

export default CustomFieldPicker;
